// extracted by mini-css-extract-plugin
module.exports = {"component":"badgeExperience_component___FmMo","component_text":"badgeExperience_component_text__1o2iT"};